// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
  <sub-header header="'ATM batch acquirers'"></sub-header>

<div class="tab-menu">
  <ul class="nav-tabs">
    <li class="active">
      <a data-target="#tab-upload" data-toggle="tab">
        Upload
      </a>
    </li>
    <li>
      <a data-target="#tab-history" data-toggle="tab">
        History
      </a>
    </li>
  </ul>
</div>

<div class="tab-content">
  <div class="tab-pane active" id="tab-upload">
    <atm-batch-acquirers-upload></atm-batch-acquirers-upload>
  </div>

  <div class="tab-pane" id="tab-history">
    <atm-batch-acquirers-upload-history></atm-batch-acquirers-upload-history>
  </div>
</div>
</section>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/atm/batch/atm-batch-acquirers.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;